import config from 'config';
import { CALL_API } from 'store/middleware/api';
import { joinPath } from 'utils/string';
import { Map } from 'immutable';   // if not imported elsewhere
import { buildAiFilterTags, completeCouplings } from './aiFilterTags';

const {
  constants: {
    API: { BASE_URL },
  },
} = config;
 
 
export const CLEAR_ALL = ('CLEAR_ALL');
export const REFRESH_SEARCH = ('REFRESH_SEARCH');
export const SET_LOCATION = ('SET_LOCATION');
export const SET_SORT = ('SET_SORT');
export const SET_PAGE = ('SET_PAGE');
export const SET_RANGE = ('SET_RANGE');
export const SET_OVERLAY = ('SET_OVERLAY');
export const SET_LAYOUT = ('SET_LAYOUT');
export const SET_ACTIVE_CONTEXT = ('SET_ACTIVE_CONTEXT');
export const TOGGLE_RANGE = ('TOGGLE_RANGE');
export const TOGGLE_SELECTION = ('TOGGLE_SELECTION');
 
export const CLEAR_FILTER = ('CLEAR_FILTER');
export const UPDATE_FILTER = ('UPDATE_FILTER');
export const LOAD_SEARCH = ('LOAD_SEARCH');
export const REMOVE_FILTER_BY_KEY = ('REMOVE_FILTER_BY_KEY');

export const SAVED_COUNT_LISTING = ('SAVED_COUNT_LISTING');
export const SAVED_COUNT_LISTING_SUCCESS = ('SAVED_COUNT_LISTING_SUCCESS');
export const SAVED_COUNT_LISTING_ERROR = ('SAVED_COUNT_LISTING_ERROR');
 
export const SEARCH_LISTING = ('SEARCH_LISTING');
export const SEARCH_LISTING_SUCCESS = ('SEARCH_LISTING_SUCCESS');
export const SEARCH_LISTING_ERROR = ('SEARCH_LISTING_ERROR');
 
export const SEARCH_MAPPINS = ('SEARCH_MAPPINS');
export const MAPPIN_SEARCH_LISTING_SUCCESS = ('MAPPIN_SEARCH_LISTING_SUCCESS');
export const MAPPIN_SEARCH_LISTING_ERROR = ('MAPPIN_SEARCH_LISTING_ERROR');
 
 
export const SAVE_LISTINGS = ('SAVE_LISTINGS');
export const SAVE_LISTINGS_SUCCESS = ('SAVE_LISTINGS_SUCCESS');
export const SAVE_LISTINGS_ERROR = ('SAVE_LISTINGS_ERROR');
 
export const SEARCH_PROPERTY = ('SEARCH_PROPERTY');
export const SEARCH_PROPERTY_SUCCESS = ('SEARCH_PROPERTY_SUCCESS');
export const SEARCH_PROPERTY_ERROR = ('SEARCH_PROPERTY_ERROR');
 
export const CLEAR_SUGGESTION = ('CLEAR_SUGGESTION');
export const SET_SUGGESTION_LABEL = ('SET_SUGGESTION_LABEL');
export const SET_SUGGESTION_VALUE = ('SET_SUGGESTION_VALUE');
export const SET_SUGGESTIONS = ('SET_SUGGESTIONS');
export const SET_RECENT_SUGGESTIONS = ('SET_RECENT_SUGGESTIONS');
export const SEARCH_SUGGESTIONS = ('SEARCH_SUGGESTIONS');
export const SEARCH_SUGGESTIONS_SUCCESS = ('SEARCH_SUGGESTIONS_SUCCESS');
export const SEARCH_SUGGESTIONS_ERROR = ('SEARCH_SUGGESTIONS_ERROR');
 
export const SEARCH_PARCEL = ('SEARCH_PARCEL');
export const SEARCH_PARCEL_SUCCESS = ('SEARCH_PARCEL_SUCCESS');
export const SEARCH_PARCEL_ERROR = ('SEARCH_PARCEL_ERROR');
 
export const GET_MAP_METRICS = ('GET_MAP_METRICS');
export const GET_MAP_METRICS_SUCCESS = ('GET_MAP_METRICS_SUCCESS');
export const GET_MAP_METRICS_ERROR = ('GET_MAP_METRICS_ERROR');
 
export const SEARCH_STATISTICS = ('SEARCH_STATISTICS');
export const SEARCH_STATISTICS_SUCCESS = ('SEARCH_STATISTICS_SUCCESS');
export const SEARCH_STATISTICS_ERROR = ('SEARCH_STATISTICS_ERROR');
 
export const EXPORT_STATISTICS = ('EXPORT_STATISTICS');
export const EXPORT_STATISTICS_SUCCESS = ('EXPORT_STATISTICS_SUCCESS');
export const EXPORT_STATISTICS_ERROR = ('EXPORT_STATISTICS_ERROR');
 
export const CLEAR_STATISTICS = ('CLEAR_STATISTICS');
export const UPDATE_STATISTICS_FILTER = ('UPDATE_STATISTICS_FILTER');
 
export const SEARCH_FAVORITES = ('SEARCH_FAVORITES');
export const SEARCH_FAVORITES_SUCCESS = ('SEARCH_FAVORITES_SUCCESS');
export const SEARCH_FAVORITES_ERROR = ('SEARCH_FAVORITES_ERROR');
 
export const GET_SAVED_SEARCHES = ('GET_SAVED_SEARCHES');
export const GET_SAVED_SEARCHES_SUCCESS = ('GET_SAVED_SEARCHES_SUCCESS');
export const GET_SAVED_SEARCHES_ERROR = ('GET_SAVED_SEARCHES_ERROR');
 
export const SAVE_SEARCH = ('SAVE_SEARCH');
export const SAVE_SEARCH_SUCCESS = ('SAVE_SEARCH_SUCCESS');
export const SAVE_SEARCH_ERROR = ('SAVE_SEARCH_ERROR');
 
export const DELETE_SEARCH = ('DELETE_SEARCH');
export const DELETE_SEARCH_SUCCESS = ('DELETE_SEARCH_SUCCESS');
export const DELETE_SEARCH_ERROR = ('DELETE_SEARCH_ERROR');
 
export const ASSIGN_SEARCH_SLOT = ('ASSIGN_SEARCH_SLOT');
export const ASSIGN_SEARCH_SLOT_SUCCESS = ('ASSIGN_SEARCH_SLOT_SUCCESS');
export const ASSIGN_SEARCH_SLOT_ERROR = ('ASSIGN_SEARCH_SLOT_ERROR');
 
export const LOCAL_CLEAR_FILTER = ('LOCAL_CLEAR_FILTER');
export const LOCAL_UPDATE_FILTER = ('LOCAL_UPDATE_FILTER');
export const LOCAL_REMOVE_FILTER = ('LOCAL_REMOVE_FILTER');
export const LOCAL_LOAD_SEARCH = ('LOCAL_LOAD_SEARCH');
 
export const FILTER_SHOW_ALL_EDIT = ('FILTER_SHOW_ALL_EDIT');
export const FILTER_SHOW_ALL_CLEAR = ('FILTER_SHOW_ALL_CLEAR');
 
export const LEAD_LIST = ('LEAD_LIST');
export const LEAD_LIST_SUCCESS = ('LEAD_LIST_SUCCESS');
export const LEAD_LIST_ERROR = ('LEAD_LIST_ERROR');
export const LEAD_LIST_CLEAR = ('LEAD_LIST_CLEAR');
 
export const FILTER_SAVE_SEARCH = ('FILTER_SAVE_SEARCH');
 
export const FILTER_LANDUSE_CODE_DROPDOWN = ('FILTER_LANDUSE_CODE_DROPDOWN');
 
 
export const SET_FAVORITE_ITEM = ('SET_FAVORITE_ITEM');
export const GET_FAVORITE_ITEM = ('GET_FAVORITE_ITEM');
 
export const RESTORE_PREVIOUS_RESULT = 'RESTORE_PREVIOUS_RESULT';
 
export const SAVE_PREVIOUS_SEARCH_STATE = "SAVE_PREVIOUS_SEARCH_STATE"
export const CLEAR_PREVIOUS_SEARCH_STATE = "CLEAR_PREVIOUS_SEARCH_STATE"
 
export const GET_SAVED_PROPERTY_LIST = "GET_SAVED_PROPERTY_LIST"
export const GET_SAVED_PROPERTY_LIST_SUCCESS = "GET_SAVED_PROPERTY_LIST_SUCCESS"
export const GET_SAVED_PROPERTY_LIST_ERROR = "GET_SAVED_PROPERTY_LIST_ERROR"

export const RESET_RANGE = "RESET_RANGE";

export const AI_APPLY_FILTERS = ('AI_APPLY_FILTERS');
export const SET_AI_SEARCH_LABEL = 'SET_AI_SEARCH_LABEL';
export const MARK_AI_SEARCH_LABEL_EARLIER = 'MARK_AI_SEARCH_LABEL_EARLIER';
export const CLEAR_AI_SEARCH_LABEL = 'CLEAR_AI_SEARCH_LABEL';

 
const request = (path, method, startType, successType, errorType, body, { afterSuccess, afterError, params, successParams, download = false, query, skipGlobalErrorHandler, meta = {} } = {}) => ({
  meta,
  [CALL_API]: {
    method,
    startType,
    successType,
    errorType,
    body,
    afterSuccess,
    afterError,
    params,
    successParams,
    query,
    download,
    skipGlobalErrorHandler,
    dislodging: true,
    path: joinPath('/resource/auth/ps4', path),
    // ...(method === 'post' && !isFormData(body) ? { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } } : {}),
  },
});
 
 
export const clearAll = () => ({ type: CLEAR_ALL });
 
export const refreshSearch = () => ({ type: REFRESH_SEARCH });
 
export const setLocation = payload => ({
  type: SET_LOCATION,
  payload,
});
 
export const setOverlay = overlay => ({ type: SET_OVERLAY, overlay });
 
export const setLayout = layout => ({ type: SET_LAYOUT, layout });
 
export const setSort = (field, ascending) => ({ type: SET_SORT, field, ascending });
 
export const setPage = page => ({ type: SET_PAGE, page });
 
export const setRange = (rangeFrom, rangeTo) => ({ type: SET_RANGE, rangeFrom, rangeTo });
 
export const toggleRange = enabled => ({ type: TOGGLE_RANGE, enabled });
 
// export const toggleSelection = id => ({ type: TOGGLE_SELECTION, id });
export const toggleSelection = (id, isChecked) => ({ type: TOGGLE_SELECTION, id, isChecked });
 
export const setActiveContext = context => ({ type: SET_ACTIVE_CONTEXT, context });

export const savedCountListings = (query, append = false) =>
  request('listing/saved_count', 'get', SAVED_COUNT_LISTING, SAVED_COUNT_LISTING_SUCCESS, SAVED_COUNT_LISTING_ERROR, null, {
    query,
    meta: { append },
  });
 
export const searchListings = (query, append = false) =>
  request('listing', 'get', SEARCH_LISTING, SEARCH_LISTING_SUCCESS, SEARCH_LISTING_ERROR, null, {
    query,
    meta: { append },
  });
 
 
export const searchMapPins = (query, append = false) =>
  request('listing/map_pins', 'get', SEARCH_MAPPINS, MAPPIN_SEARCH_LISTING_SUCCESS, MAPPIN_SEARCH_LISTING_ERROR, null, {
    query,
    meta: { append },
  });
 
// export const searchListings = query => request('listing', 'get', SEARCH_LISTING, SEARCH_LISTING_SUCCESS, SEARCH_LISTING_ERROR, null, { query });
 
export const saveListings = (query, selection, selectionInversed, groupType, groupName, afterSuccess) => request('user/listings', 'post', SAVE_LISTINGS, SAVE_LISTINGS_SUCCESS, SAVE_LISTINGS_ERROR, { ...query, selection, selectionInversed }, { query: { groupType, groupName }, afterSuccess });
 
 
export const searchProperty =
  (query, options = {}) => (dispatch, getState) => {
    const previousState = getState();
 
    return dispatch(
      request(
        'property',
        'get',
        SEARCH_PROPERTY,
        SEARCH_PROPERTY_SUCCESS,
        SEARCH_PROPERTY_ERROR,
        null,
        {
          query,
          meta: { previousState, ...(options.meta || {}) },  // send full state in meta
          ...options,
        },
      ),
    );
  };
 
 
export const clearSuggestion = () => ({ type: CLEAR_SUGGESTION });
 
export const setSuggestionLabel = label => ({ type: SET_SUGGESTION_LABEL, label });
 
export const setSuggestionValue = value => ({ type: SET_SUGGESTION_VALUE, value });
 
export const setSuggestions = items => ({ type: SET_SUGGESTIONS, items });
 
export const setRecentSuggestions = (recentItems, clear = false) => ({ type: SET_RECENT_SUGGESTIONS, recentItems, clear });
 
export const searchSuggestions = q => request('property/suggestionsnew', 'get', SEARCH_SUGGESTIONS, SEARCH_SUGGESTIONS_SUCCESS, SEARCH_SUGGESTIONS_ERROR, null, { query: { q }, successParams: { query: q } });
 
export const clearFilter = () => ({ type: CLEAR_FILTER });
 
export const updateFilter = data => ({ type: UPDATE_FILTER, data });
 
export const removeFilterById = (id) => ({ type: REMOVE_FILTER_BY_KEY, id });
 
export const loadSearch = search => ({ type: LOAD_SEARCH, search });
 
 
export const searchParcel = (latitude, longitude, afterSuccess) => request(`map/parcels/${latitude}/${longitude}/property`, 'get', SEARCH_PARCEL, SEARCH_PARCEL_SUCCESS, SEARCH_PARCEL_ERROR, null, { afterSuccess });
 
export const getMapMetrics = () => request('map/statistics/metrics', 'get', GET_MAP_METRICS, GET_MAP_METRICS_SUCCESS, GET_MAP_METRICS_ERROR);
 
 
export const clearStatistics = () => ({ type: CLEAR_STATISTICS });
 
export const updateStatisticsFilter = data => ({ type: UPDATE_STATISTICS_FILTER, data });
 
export const searchStatistics = (location, filter) => request('statistics/area', 'get', SEARCH_STATISTICS, SEARCH_STATISTICS_SUCCESS, SEARCH_STATISTICS_ERROR, null, { location, query: { ...location, ...filter } });
 
export const exportStatistics = (location, filter) => request('statistics/area/report', 'get', EXPORT_STATISTICS, EXPORT_STATISTICS_SUCCESS, EXPORT_STATISTICS_ERROR, null, { query: { ...location, ...filter }, download: true });
 
 
export const getSavedSearches = refreshed => request('user/new/searches', 'get', GET_SAVED_SEARCHES, GET_SAVED_SEARCHES_SUCCESS, GET_SAVED_SEARCHES_ERROR, null, { refreshed });
 
export const searchFavorites = (query, ignoreZeroCounts = false) =>
  request('user/new/searches/canned', 'get', SEARCH_FAVORITES, SEARCH_FAVORITES_SUCCESS, SEARCH_FAVORITES_ERROR, null, {
    query,
    meta: { ignoreZeroCounts },
  });
 
export const searchLeadList = query => request('user/searches/leadList', 'get', LEAD_LIST, LEAD_LIST_SUCCESS, LEAD_LIST_ERROR, null, { query });
 
export const saveSearch = (search, afterSuccess) =>
  request(
    'user/searches',
    'put',
    SAVE_SEARCH,
    SAVE_SEARCH_SUCCESS,
    SAVE_SEARCH_ERROR,
    search,
    { afterSuccess }
  );
 
export const deleteSearch = id => request('user/searches', 'delete', DELETE_SEARCH, DELETE_SEARCH_SUCCESS, DELETE_SEARCH_ERROR, [{ id }]);
 
export const assignSearchSlot = (id, slot) => request(`user/searches/slots/${slot}/${id}`, 'put', ASSIGN_SEARCH_SLOT, ASSIGN_SEARCH_SLOT_SUCCESS, ASSIGN_SEARCH_SLOT_ERROR);
 
 
export const updateLocalFilter = (localFilter) => ({ type: LOCAL_UPDATE_FILTER, localFilter });
export const removeLocalFilter = (id) => ({ type: LOCAL_REMOVE_FILTER, id });
export const clearLocalFilter = (id) => ({ type: LOCAL_CLEAR_FILTER });
export const showAllButtonEditOption = (data) => ({ type: FILTER_SHOW_ALL_EDIT, data });
export const clearButtonEditOption = () => ({ type: FILTER_SHOW_ALL_CLEAR });
 
 
 
export const clearLeadListApiData = () => ({ type: LEAD_LIST_CLEAR });
export const setSelectedSaveSearch = (name) => ({ type: FILTER_SAVE_SEARCH, name });
 
export const setFavoriteItem = (name) => ({ type: SET_FAVORITE_ITEM, name });
 
export const restorePreviousResult = () => ({ type: RESTORE_PREVIOUS_RESULT });
export const savePreviousSearchState = (prevState) => ({
  type: SAVE_PREVIOUS_SEARCH_STATE,
  payload: prevState,
});
 
export const clearPreviousSearchState = () => ({
  type: CLEAR_PREVIOUS_SEARCH_STATE,
});

export const resetRange = () => ({
  type: RESET_RANGE,
});

// ATAI-286: which AI Search search the results grid is showing. Set once an
// AI Search apply has landed, marked "earlier" when a chat turn ends without
// applying a search, cleared when the conversation starts fresh.
export const setAiSearchLabel = (summary) => ({ type: SET_AI_SEARCH_LABEL, summary });
export const markAiSearchLabelEarlier = () => ({ type: MARK_AI_SEARCH_LABEL_EARLIER });
export const clearAiSearchLabel = () => ({ type: CLEAR_AI_SEARCH_LABEL });
 
export const getSavedPropertyList = (id, afterSuccess) => request(`user/new/savedProperties/${id}`, 'get', GET_SAVED_PROPERTY_LIST, GET_SAVED_PROPERTY_LIST_SUCCESS, GET_SAVED_PROPERTY_LIST_ERROR, null, { afterSuccess });

// ── AI Search Assistant ──────────────────────────────────────────────────────

// Keys the AI is allowed to set on `location`. Anything else (notably a
// hallucinated `propertyId`, which would flip the search into Property mode) is
// dropped before the payload reaches the reducer.
const AI_LOCATION_FIELDS = ['cityId', 'countyId', 'zip', 'shapeDefinition', 'label', 'fips'];

const whitelistAiLocation = (location) => {
  if (!location || typeof location !== 'object') return null;
  const out = AI_LOCATION_FIELDS.reduce((acc, k) => {
    if (location[k] != null && location[k] !== '') acc[k] = location[k];
    return acc;
  }, {});
  return Object.keys(out).length ? out : null;
};

/**
 * Atomically apply AI-generated search filters (and optionally a location) in a
 * single state transition, so the search auto-fires exactly once. Snapshots the
 * pre-apply state first so the FilterActionCard's Undo can restore it.
 *
 * @param {object}  payload
 * @param {object}  payload.filters        Filter fields (constrained to FilterFields in the reducer).
 * @param {object}  [payload.location]     { cityId | countyId | zip | shapeDefinition, label }.
 * @param {boolean} [payload.clearExisting] true → replace current filters; false → merge.
 */
export const aiApplyFilters = ({ filters = {}, location = null, clearExisting = true } = {}) =>
  (dispatch, getState) => {
    // Complete any field couplings the manual UI sets (e.g. foreclosureStatus2
    // needs its include flags) so AI filters narrow like a human search.
    const completedFilters = completeCouplings(filters || {});

    // Refresh the undo snapshot to the state right before THIS apply.
    dispatch(clearPreviousSearchState());
    dispatch(savePreviousSearchState(getState()));
    dispatch({
      type: AI_APPLY_FILTERS,
      filters: completedFilters,
      location: whitelistAiLocation(location),
      clearExisting,
    });

    // Sync the UI "applied filters" layer (left-panel tags + Lead List highlight)
    // so an AI apply looks exactly like a manual search.
    if (clearExisting) dispatch(clearLocalFilter());
    const { records, favoriteItem } = buildAiFilterTags(completedFilters);
    if (records.length) dispatch(updateLocalFilter(records));
    if (favoriteItem) dispatch(setFavoriteItem(favoriteItem));
    // Clear a stale Lead List highlight when replacing filters with no new preset.
    else if (clearExisting) dispatch(setFavoriteItem(null));
  };

/**
 * Location autocomplete for the AI's `lookup_locations` tool. A bare fetch that
 * resolves to the suggestion list — deliberately NOT the `searchSuggestions`
 * thunk, so it never writes to Redux `suggestion` state and clobbers the
 * Header's autocomplete dropdown.
 *
 * @param {string} q  Free-text location query.
 * @returns {Promise<Array>} Suggestion items (possibly empty).
 */
export const lookupLocations = (q) => {
  const query = (q || '').trim();
  if (!query) return Promise.resolve([]);
  const url = `${BASE_URL}${joinPath('/resource/auth/ps4', 'property/suggestionsnew')}?q=${encodeURIComponent(query)}`;
  return fetch(url, {
    method: 'GET',
    headers: { 'X-Auth-Token': window.appAuthToken },
  })
    .then((r) => (r.ok ? r.json() : Promise.reject(new Error(`Lookup failed (${r.status})`))))
    .then((data) => {
      if (Array.isArray(data)) return data;
      if (data && Array.isArray(data.items)) return data.items;
      if (data && Array.isArray(data.results)) return data.results;
      return [];
    });
};
